import { Button, Col, Form, Input, Row, Select, notification } from "antd";
import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomSpinner } from "../utils/CustomComponents";

const MechanicNew = ({ history }) => {
	const [form] = Form.useForm();
	const [initialValues, setInitialValues] = useState({});
	const [plantOptions, setPlantOptions] = useState([]);
	const [subplantOptions, setSublantOptions] = useState([]);
	const [loading, setLoading] = useState(false);
	const [loadingForm, setLoadingForm] = useState(true);
	const [loadingSubplant, setLoadingSubplant] = useState(true);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getPlant();
	}, []);

	const getPlant = async () => {
		const url = api + "/plant/list/57Concrete";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let plantList = [];
			data.payload.map((item) => {
				plantList.push({
					label: item.name,
					value: item._id,
				});
			});
			setPlantOptions(plantList);
			setInitialValues({
				...initialValues,
				name: "",
				email: "",
				password: "",
				confirm: "",
				plant: "",
				subplant: "",
				prefix: "+1",
			});
			setLoadingForm(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getSublant = async (currentPlant) => {
		const url = api + `/plant/${currentPlant}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let subplantList = [];
			data.subplants.map((item) => {
				subplantList.push({
					label: item.name,
					value: item.name,
				});
			});
			setSublantOptions(subplantList);
			setLoadingSubplant(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const duplicatedUserEmail = async (email) => {
		const url = api + "/useremail/" + email;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			return data.found;
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const duplicatedUserPhone = async (phone) => {
		const url = api + `/userphone/+1${phone}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			return data.found;
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const createBatch = async (data) => {
		const user = {
			name: data.name,
			email: data.email,
			password: data.password,
			plant: data.plant,
			subplant: data.subplant,
			role: "Batch",
			phone: `+1${data.phone}`,
		};

		try {
			let url = api + "/users";
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			await axios.post(url, user);
			openNotification("success", "Success", "Mechanic created");
			setLoading(false);
			history.push("/batch/list");
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to create user");
			console.error(err.message);
			return null;
		}
	};

	const validateUser = async (values) => {
		const duplicadoEmail = await duplicatedUserEmail(values.email);
		const duplicadoPhone = await duplicatedUserPhone(values.phone);
		if (duplicadoEmail) {
			openNotification(
				"warning",
				"Duplicated user",
				"User already exist with Email"
			);
			setLoading(false);
		} else if (duplicadoPhone) {
			openNotification(
				"warning",
				"Duplicated user",
				"User already exist with Phone"
			);
			setLoading(false);
		} else {
			createBatch(values);
		}
	};

	const onFinish = (values) => {
		setLoading(true);
		validateUser(values);
	};

	const onChangePlant = (value) => {
		form.setFieldsValue({ subplant: "" });
		setLoadingSubplant(true);
		getSublant(value);
	};

	const filterOption = (input, option) =>
		(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

	const prefixSelector = (
		<Form.Item name="prefix" noStyle>
			<Select
				style={{
					width: 70,
				}}
			>
				<Select.Option value="+1">+1</Select.Option>
			</Select>
		</Form.Item>
	);

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				onFinish={onFinish}
				initialValues={initialValues}
			>
				<Row gutter={16}>
					<Col span={24}>
						<Form.Item
							label="Name"
							name="name"
							rules={[
								{
									required: true,
									message: "Please fill name",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Email"
							name="email"
							rules={[
								{
									type: "email",
									message: "The input is not valid E-mail",
								},
								{
									required: true,
									message: "Please fill email",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Phone"
							name="phone"
							rules={[
								{
									required: true,
									message: "Please fill phone",
								},
								{
									len: 10,
									max: 10,
									message: "Phone number must have 10 numbers",
								},
							]}
						>
							<Input size="large" addonBefore={prefixSelector} />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							name="password"
							label="Password"
							rules={[
								{
									required: true,
									message: "Please input your password",
								},
								{
									min: 5,
									message: "Password must have at least 5 characters",
								},
							]}
							hasFeedback
						>
							<Input.Password size="large" />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							name="confirm"
							label="Confirm Password"
							dependencies={["password"]}
							hasFeedback
							rules={[
								{
									required: true,
									message: "Please confirm your password",
								},
								{
									min: 5,
									message: "Password must have at least 5 characters",
								},
								({ getFieldValue }) => ({
									validator(_, value) {
										if (!value || getFieldValue("password") === value) {
											return Promise.resolve();
										}
										return Promise.reject(
											new Error(
												"The new password that you entered do not match!"
											)
										);
									},
								}),
							]}
						>
							<Input.Password size="large" />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Plant"
							name="plant"
							rules={[
								{
									required: true,
									message: "Please select a plant",
								},
							]}
						>
							<Select
								showSearch
								placeholder={`Select plant`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={plantOptions}
								onChange={onChangePlant}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Subplant"
							name="subplant"
							rules={[
								{
									required: true,
									message: "Please select a subplant",
								},
							]}
						>
							<Select
								showSearch
								placeholder={`Select subplant`}
								optionFilterProp="children"
								size="large"
								filterOption={filterOption}
								options={subplantOptions}
								disabled={loadingSubplant}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Button type="primary" htmlType="submit" loading={loading}>
					Create
				</Button>
			</Form>
		);
	};

	return (
		<Layout title="New Batch" description="Create new batch" type="medium">
			{contextHolder}
			{loadingForm ? <CustomSpinner /> : <CustomForm />}
		</Layout>
	);
};

export default MechanicNew;
